import React, {
    Component
  }                         from 'react';
  import PropTypes          from 'prop-types';
  import {
    AnimatedView,
    StatsCard,
    WorkProgress
  }                         from '../../../../components';
  //import { getDealList } from '../../../redux/actions/dealActions';
  
  import { getMonthandYear, getProgressReport} from '../../../../redux/actions/salesPersonActions';
  import {renderAlert,clearAlert} from '../../../../redux/actions/alertsActions';
  import { connect }    from 'react-redux';
  import {
    Row,
    Col,
    Button,
    FormGroup,
    FormControl,
    ControlLabel,
    Alert,
    Panel,
    PanelGroup
    
  }                     from 'react-bootstrap';
  import { withRouter } from 'react-router';
  import {
    bindActionCreators,
    compose
  }                     from 'redux';
  import { createBrowserHistory } from 'history';
  import loader from '../../../../style/loader/loader.scss';
  import { Link } from "react-router-dom";
  import {
    Breadcrumb as BreadcrumbComponent
  }                        from '../../../../components';
  import isEmpty from 'lodash.isempty';

  
  const history = createBrowserHistory();

  let isLoading='false', reportData='', progress='';
  class Progress extends Component {

    constructor(props){
      super(props);
      this.state={
        //path: ['Home', 'Sales person', 'Dashboard'], 
        show: false,
        alertMessage:'',
        disabled: false,
        reportData:[],
        monthyeardata:[],
        groupedData:[],
        groupby:'Market'
      }
     
      this.handleDismiss = this.handleDismiss.bind(this);
      this.handleShow = this.handleShow.bind(this);
    }

    handleDismiss() {
      this.setState({ show: false });
    }
  
    handleShow() {
      this.setState({ show: true });
    }

    handleMonthChange(e){
    
      if(`${e.target.name}Error` !== ''){
       
        this.setState({[`${e.target.name}Error`]:''})
      }
     
      this.setState({[e.target.name]:e.target.value})
      const postData={
        selectMonth: e.target.value,
        group_by:this.state.groupby
      }
      this.props.getProgressReport(postData);
      
    }

    handleGroupbyChange(e){
    
      if(`${e.target.name}Error` !== ''){
       
        this.setState({[`${e.target.name}Error`]:''})
      }
     
      this.setState({[e.target.name]:e.target.value})
      const postData={
        selectMonth: this.state.monthyear,
        group_by:e.target.value
      }
      this.props.getProgressReport(postData);
      
    }

    componentWillMount(){
      this.props.clearAlert ();
      this.handleDismiss();
      this.props.getMonthandYear();
      isLoading="true";
    }

    componentWillReceiveProps(nextProps){     
      if(this.props.error !== nextProps.error){
        if(nextProps.error){
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('warning',nextProps.error);
          isLoading="false";
          
        }
      } 
     

      if(this.props.monthyear !== nextProps.monthyear){
        if(!isEmpty(nextProps.monthyear)){
          this.setState({monthyeardata: nextProps.monthyear.data})
          
          let month= nextProps.monthyear.data;
          const postData={
            selectMonth: month[0],
            group_by:this.state.groupby
          }
          this.props.getProgressReport(postData);
        }
      }

      if(this.props.progressData !== nextProps.progressData){
        if(nextProps.progressData){
          this.setState({reportData: nextProps.progressData.data})
          isLoading="false";
        }
      } 

      if(this.props.groupedData !== nextProps.groupedData){
        if(nextProps.groupedData){
          this.setState({groupedData: nextProps.groupedData.data})
          isLoading="false";
        }
      } 

      if(nextProps.message){
        this.handleShow();
        this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
      }
     
  }


  handleSubmit(e){
    e.preventDefault();
    const err = this.validate();
    let formData;

    if(!err) {
      this.setState({sales: ''})
      isLoading = 'true';
      if(this.state.range == true){
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: dateRange[0],
          endDate: dateRange[1],
          catID: this.state.catID,
          merchantTypeID: this.state.merchantTypeID,
        }
      }else{
        formData = {
          startDate: this.state.startDate,
          catID: this.state.catID,
          merchantTypeID: this.state.merchantTypeID,
        }
      }

      this.props.getSalesPersonReport(formData);
    }
  }



    render() {
    
     if(this.props.error){
      isLoading="false";
    }
   
     
      if ( !isEmpty(this.state.reportData)){
        progress= this.state.reportData;
            
      }
       
        return (
          <div className="col-lg-12 add-sub-admin">
        {(isLoading =='true') ? 
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }
       
       
        <form onSubmit={this.handleSubmit}>
        <div className="panel">
          <header className="panel-heading">Team Progress</header>
          <div className="panel-body">
            <Row>
             
             
              <Col md={3} xs={12}>
                <FormGroup controlId="monthyear">
                  <ControlLabel>Month&Year</ControlLabel>
                  <FormControl componentClass="select" style={{borderColor:this.state.monthyearError}} name="monthyear" onChange={this.handleMonthChange.bind(this)} value={this.state.monthyear}>
                
                    {(!isEmpty(this.state.monthyeardata)) && 
                      this.state.monthyeardata.map((month, index) => 
                        <option key={index} value={month}>{month}</option>
                      )
                    }
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3} xs={12}>
                  <FormGroup controlId="catID">
                    <ControlLabel>Grouped By</ControlLabel>
                    <FormControl componentClass="select" name="groupby" onChange={this.handleGroupbyChange.bind(this)} value={this.state.groupby}>
                      <option value="Market">All Markets</option>
                      <option value="SalesPerson">All Reps</option>
                    </FormControl>
                  
                  </FormGroup>

                  
                </Col>
            </Row>
         
          </div>
        </div> 
        </form>
       

        <div className="panel">
      
          <div className="panel-body table-responsive">

            <table className="table table-hover">
              <thead>
                  <tr>
                      <th colSpan="7" style={{textAlign:'center'}}>{(this.state.groupby=="Market")? "Market": "Rep"}/ Sales Rep.</th>
                      </tr>
                      
                       <tr>
                            <th> </th>
                            <th> Created</th> 
                            <th> Opened </th> 
                            <th> Signed</th> 
                            <th> Premium</th>
                            <th>Unique Merchants</th>
                            <th> New Merchants </th> 
                        </tr>
                </thead>
                <tbody>
                  
                      <tr>
                        <td>
                          <b>{(this.state.groupby=="Market")? "All Markets" : "All Reps"} </b>
                          
                        </td>
                        </tr>
                        <tr>
                          <td> Combined Stats</td>
                          <td>  {progress.created} </td>
                          <td> {progress.opened} </td>
                          <td> {progress.signed}</td>
                          <td> {progress.premium} </td>
                          <td> {progress.unique_merchants}</td>
                          <td> {progress.newMerchants}</td>
                                 
                         
                        </tr>
                   
                  </tbody>
              </table>
          </div>
        </div>
       
      </div>
      
      );
    }
  }

  const mapStateToProps = state => ({
    
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    monthyear:  state.salesPersonReducer.monthyear,
    progressData: state.salesPersonReducer.progressData,
    error: state.salesPersonReducer.error,
    
  })

  export default compose(
    withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
    connect(mapStateToProps,{renderAlert,clearAlert,getMonthandYear, getProgressReport})
  )(Progress);



// WEBPACK FOOTER //
// ./src/app/views/salesPerson/salesTeam/progress/Progress.js